import { createElement } from "commonAssets/js/helpers";

/**
 * Get the wrapper element for the claim fields.
 *
 * @returns {Element} The wrapper element.
 */
function getWrapper() {
    return document.querySelector('#claim-fields').lastElementChild;
}

/**
 * Initialize the claim fields.
 */
function init() {
    const wrapper = getWrapper();
    wrapper.classList.add('row');

    // Move participant's social security number and participant's date of birth to the contact information section
    const contactInfo = document.querySelector('div#contact-information > div.row');
    const participantSSN = wrapper.querySelector('#social_security_number').parentElement;
    const participantDateOfBirth = wrapper.querySelector('#date_of_birth').parentElement;
    contactInfo.appendChild(participantSSN);
    contactInfo.appendChild(participantDateOfBirth);

    // For some reason, the phone input labels are not being displayed correctly.
    // This is a temporary fix to ensure the labels are displayed correctly.
    fixPhoneInputLabels();
}

/**
 * Fix the phone input labels.
 */
function fixPhoneInputLabels() {
    const wrapper = getWrapper();
    const phoneInput = wrapper.querySelectorAll('input[type="tel"]');
    phoneInput.forEach(input => {
        // insert the label before the input
        const errorSpan = createElement('span', { class: 'error' });
        const label = createElement('label', { 
            for: input.id,
            class: 'form-label'
        }, [
            `${input.dataset.label} ${input.required ? '*' : ''}`,
            errorSpan
        ]);
        input.parentNode.insertBefore(label, input);
    });
}

export default {
    init
}